// Shared, authoritative game rules — imported by both the party/ Durable
// Object (multiplayer) and frontend/'s offline single-player mode, so the
// two can never drift out of sync (they used to be hand-duplicated).

export type OrderType = 'sequential' | 'random';

export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export function buildLetterOrder(orderType: OrderType): string[] {
  if (orderType !== 'random') return [...ALPHABET];
  const a = [...ALPHABET];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Word must be non-empty (after trim) and start with the target letter.
export function wordStartsWithLetter(word: string, letter: string): boolean {
  const trimmed = word.trim();
  return trimmed.length > 0 && trimmed[0].toUpperCase() === letter;
}
